"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiAccountAttachPaymentCardDto = void 0;
const swagger_1 = require("../../../../swagger-fake");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
let BillingApiAccountAttachPaymentCardDto = class BillingApiAccountAttachPaymentCardDto {};
__decorate([(0, swagger_1.ApiProperty)({
  description: "Контрагент",
  format: "uuid",
  type: String,
  nullable: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsUUID)(4), __metadata("design:type", Object)], BillingApiAccountAttachPaymentCardDto.prototype, "contractorId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Платёжный провайдер.",
  format: "uuid",
  type: String
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsUUID)(4), __metadata("design:type", String)], BillingApiAccountAttachPaymentCardDto.prototype, "providerId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Страна плательщика (опционально, если известна)"
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsString)(), __metadata("design:type", String)], BillingApiAccountAttachPaymentCardDto.prototype, "countryCode", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Имя плательщика"
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsString)(), __metadata("design:type", String)], BillingApiAccountAttachPaymentCardDto.prototype, "firstName", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Фамилия плательщика"
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsString)(), __metadata("design:type", String)], BillingApiAccountAttachPaymentCardDto.prototype, "lastName", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Эл. почта плательщика"
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsEmail)(), __metadata("design:type", String)], BillingApiAccountAttachPaymentCardDto.prototype, "email", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Телефон плательщика"
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsPhoneNumber)(), __metadata("design:type", Object)], BillingApiAccountAttachPaymentCardDto.prototype, "phone", void 0);
BillingApiAccountAttachPaymentCardDto = __decorate([(0, class_transformer_1.Exclude)()], BillingApiAccountAttachPaymentCardDto);
exports.BillingApiAccountAttachPaymentCardDto = BillingApiAccountAttachPaymentCardDto;
